var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "ffmpeg合并视频文件-对于-mpeg-格式的视频-可以直接连接"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#ffmpeg合并视频文件-对于-mpeg-格式的视频-可以直接连接"
    }
  }, [_vm._v("#")]), _vm._v(" ffmpeg合并视频文件，对于 MPEG 格式的视频，可以直接连接：")]), _vm._v(" "), _c('div', {
    staticClass: "language- line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("ffmpeg -i \"concat:input1.mpg|input2.mpg|input3.mpg\" -c copy output.mpg\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br')])]), _c('p', [_vm._v("对于非 MPEG 格式容器，但是是 MPEG 编码器（H.264、DivX、XviD、MPEG4、MPEG2、AAC、MP2、MP3 等），可以包装进 TS 格式的容器再合并。在新浪视频，有很多视频使用 H.264 编码器，可以采用这个方法")]), _vm._v(" "), _c('div', {
    staticClass: "language- line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("ffmpeg -i input1.flv -c copy -bsf:v h264_mp4toannexb -f mpegts input1.ts\nffmpeg -i input2.flv -c copy -bsf:v h264_mp4toannexb -f mpegts input2.ts\nffmpeg -i input3.flv -c copy -bsf:v h264_mp4toannexb -f mpegts input3.ts\nffmpeg -i \"concat:input1.ts|input2.ts|input3.ts\" -c copy -bsf:a aac_adtstoasc -movflags +faststart output.mp4\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "ffmpeg-下载-m3u8-直播流"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#ffmpeg-下载-m3u8-直播流"
    }
  }, [_vm._v("#")]), _vm._v(" ffmpeg 下载 m3u8 直播流")]), _vm._v(" "), _c('div', {
    staticClass: "language- line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("ffmpeg -i http://www.abc.com/aaa.m3u8 \"filename.mp4\"\n\nffmpeg -live_start_index -99999 -i https://host.to/index.m3u8 -c copy -bsf:a aac_adtstoasc outputtt.mp4\n\nffmpeg -i \"http://host.to/index.m3u8\" -bsf:a aac_adtstoasc -vcodec copy -c copy -crf 50 file.mp4\n\nffmpeg -i 'https://host.to/playlist.m3u8' -c copy -o '~/filename.ts'\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br')])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };